// Libraries
import styled, { css } from 'styled-components'

// Components
import { Body, Icon } from 'heeds-ds'

// Assets
import workoutImage from 'assets/images/exercise-223.png'

type Props = {
  margin?: string
  padding?: string
  transparent?: boolean
  thumbnail?: string
}

export const Container = styled.div<Props>`
  ${({ margin, padding, theme, transparent }) => css`
    align-items: center;
    background: ${transparent ? 'transparent' : theme.colors.surface.default};
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    margin: ${margin || '0px'};
    padding: ${padding || '16px'};
    width: 100%;

    @media screen and (min-width: ${theme.breakpoints.desktop}px) {
      border-radius: 0px;
      padding: ${padding || '12px 8px 12px 0'};
    }
  `}
`

export const Image = styled.img`
  padding: 32px 24px 56px;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    min-height: 377px;
  }
`

export const Label = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 0 0 16px;
  width: 100%;
`

export const Media = styled.div<Props>`
  align-items: center;
  background: linear-gradient(rgba(43, 42, 99, 0.45), rgba(43, 42, 99, 0.45)),
    url(${({ thumbnail }) => thumbnail || workoutImage});
  background-size: cover;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  min-width: 40px;
`

export const ModalContainer = styled.div`
  padding: 24px 0;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 0 24px;
    width: 602px;
  }
`

export const ModalTop = styled.div`
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 30px 16px 16px;
  position: relative;
  ::after {
    background-color: ${({ theme }) => theme.colors.icon.disabled};
    content: '';
    height: 1.5px;
    opacity: 0.3;
    position: absolute;
    top: 100%;
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 24px 16px 16px;
  }
`

export const Description = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.subdued,
  type: 'copy5',
}))``

export const PlayIcon = styled(Icon).attrs((props) => ({
  iconName: 'playCircle',
  color: props.theme.colors.icon.onPrimary,
}))``

export const Title = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.secondary,
  type: 'copy4',
  weight: 700,
}))``
